import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#sizes" }),
  /*#__PURE__*/_createTextVNode(" Sizes ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Besides default size, Tag component provides three additional sizes for you to choose among different scenarios. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Default")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Medium")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Small")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Mini")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_tag, null, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_el_tag, { size: "medium" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(_component_el_tag, { size: "small" }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }),
      _createVNode(_component_el_tag, { size: "mini" }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code4), 1)
        ]),
        _: 1
      })
    ])
  ]))
}